import { httpClient } from '@/core/api/http-client'
import type { Role, RoleInput } from '@/domain/entities/role.entity'
import type { RoleRepository } from '@/domain/repositories/role.repository'
import { unwrap, unwrapList } from '@/infrastructure/shared/unwrap'
import type { RoleDto } from './role.dto'
import { roleMapper } from './role.mapper'

export class RoleHttpRepository implements RoleRepository {
  async list(): Promise<Role[]> {
    const raw = await httpClient.get<unknown>('/roles')
    return unwrapList<RoleDto>(raw).map(roleMapper.toRole)
  }

  async get(id: string): Promise<Role> {
    const raw = await httpClient.get<unknown>(`/roles/${id}`)
    return roleMapper.toRole(unwrap<RoleDto>(raw))
  }

  async create(input: RoleInput): Promise<Role> {
    const raw = await httpClient.post<unknown>('/roles', {
      name: input.name,
      permission_codes: input.permissionCodes,
    })
    return roleMapper.toRole(unwrap<RoleDto>(raw))
  }

  async update(id: string, input: RoleInput): Promise<Role> {
    const raw = await httpClient.put<unknown>(`/roles/${id}`, {
      name: input.name,
      permission_codes: input.permissionCodes,
    })
    return roleMapper.toRole(unwrap<RoleDto>(raw))
  }

  async remove(id: string): Promise<void> {
    await httpClient.delete(`/roles/${id}`)
  }
}
